var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarJobTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.91 -166.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.43,173.5c-.41.34-.94.55-1.52.55s-1.11-.21-1.52-.55c-.97.43-1.65,1.41-1.65,2.54v1.33c0,.07.06.13.13.13h6.08c.07,0,.13-.06.13-.13v-1.33c0-1.13-.68-2.1-1.65-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.91,169.82c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.81,183.62l-5.47-5.47c.78-1.22,1.2-2.62,1.2-4.09,0-4.2-3.42-7.63-7.63-7.63s-7.63,3.42-7.63,7.63,3.42,7.63,7.63,7.63c1.48,0,2.88-.42,4.09-1.2l5.47,5.47c.31.31.71.48,1.15.48s.84-.17,1.15-.47l.04-.04c.31-.31.48-.72.48-1.15s-.17-.84-.48-1.15ZM36.67,178.98s-.09.07-.15.11c-1.05.76-2.3,1.16-3.61,1.16-3.41,0-6.19-2.78-6.19-6.19s2.78-6.19,6.19-6.19,6.19,2.78,6.19,6.19c0,1.32-.4,2.57-1.17,3.62-.03.05-.07.1-.11.16-.33.42-.71.8-1.15,1.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarJobTemplate);
export default __webpack_public_path__ + "static/media/sidebar_job_template.6f76a0b7fc70038a12315daef823e41f.svg";
export { ForwardRef as ReactComponent };